<script setup lang="ts">
const props = defineProps<{ item: { question: string, answer: string } }>();
const isOpen = ref(false);
</script>

<template>
    <Accordion
        v-model="isOpen"
        class="w-full h-min cursor-pointer rounded-2xl border-[1px] border-gray-300"
        :class="isOpen ? 'bg-gray-50' : 'hover:opacity-50 transition-opacity duration-300'"
    >
        <template #head="{ openAccordion }">
            <div class="flex justify-between items-start p-5" @click="openAccordion">
                <h3 class="text-start text-[.875rem] leading-[1.625rem] w-[95%]">{{ item.question }}</h3>
                <Icon
                    name="maki:cross"
                    class="transition-transform duratnion-300 mt-2"
                    :class="!isOpen && 'rotate-45'"
                    size="12"
                />
            </div>
        </template>
        <template #body>
            <p class="text-gray-500 text-body2-semibold px-5 pb-5" v-html="item.answer" />
        </template>
    </Accordion>    
</template>